import { TemplateData, TemplateParams } from '.';

const customEmail = ({
  defaultPlaceholders,
  messages
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: '',
    contentAfterButton: '',
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: '',
    subject: ''
  },
  placeholders: {
    ...defaultPlaceholders
  },
  title: messages.emailTypeCustomEmail
});

export default customEmail;
